import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import NursingHomeExportModal from 'components/Modals/ExportModal/NursingHomeExportModal'
import {
  getNursingHomesSummaryForTable,
  listNursingHomesForTable,
} from 'services/nursingHome'
import { NursingHomesFilterset } from './NursingHomesFilterset'
import { useNursingHomesTableCols } from './NursingHomesTableColumns'

const sortableFields: string[] = [
  'provider_name',
  'number_of_certified_beds',
  'average_number_of_residents_per_day',
  'overall_rating',
  'health_inspection_rating',
  'qm_rating',
  'staffing_rating',
  'address',
  'city',
  'state',
  'zip_code',
  'projected_meals_per_day',
  'ownership_type',
  'provider_type',
  'continuing_care_retirement_community',
  'note_count',
  'contact_count',
  'deal_count',
  'sales_stages',
  'account_owners',
  'taglist',
  'distributors',
  'gpos',
]

export const nursingHomesTableConfig = defineTargetTableConfig({
  // Nursing home detail link reads `nursinghome.id` (see NursingHomesTableColumns
  // name cell). App vertical `nursinghome` maps to unified `nursing_home`.
  vertical: 'nursinghome',
  rowConfig: { nestKey: 'nursinghome' },
  filterIdentifier: 'NURSING_HOME_TABLE',
  savedPresetsIdentifier: 'NURSING_HOME_TABLE',
  companyTypeSlug: 'healthcare-nursinghomes',
  tableTypeSlug: 'healthcare-nursinghomes',
  sortableFields,
  preferredGroupOrder: [
    'Target Attributes',
    'Campaigns and Deals',
    'Dining Services',
    'Senior Living Insights',
  ],
  searchPlaceholder: 'Search nursing homes by name',
  useColumns: useNursingHomesTableCols,
  Filterset: NursingHomesFilterset,
  ExportModal: NursingHomeExportModal,
  // Standalone openapi-codegen service fns (services/nursingHome) replaced the
  // legacy `api.getNursingHomesList` / `api.getNursingHomesSummary` hook methods
  // on dev — drop-in (same response shapes), so the resolver returns them directly.
  resolveLegacyActions: () => ({
    listAction: listNursingHomesForTable,
    summaryAction: getNursingHomesSummaryForTable,
  }),
})

export function NursingHomesTable(
  props: Omit<TargetTableProps, 'AfterSearchComponent'>
) {
  return <TargetTable config={nursingHomesTableConfig} {...props} />
}
